import { Injectable } from '@angular/core';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { exhaustMap, map, switchMap, catchError, tap } from 'rxjs/operators';
import { Action } from '@ngrx/store/src/models';
import { ICategory } from 'src/app/shared/models/category/ICategory';
import {
  CategoriesActionTypes,
  GetCategoriesSuccess,
  GetCategoryItemSuccess,
  GetCategoriesError,
  GetCategorySuccess
} from '../../actions/categories/categories.actions';
import { CategoriesService } from '../../services/categories/categories.service';

@Injectable()
export class CategoriesEffects {
  @Effect()
  public getCategories(): Observable<Action> {
    return this.actions.pipe(
      ofType(CategoriesActionTypes.GET_CATEGORIES),
      exhaustMap((action: any) =>
        this.categoriesService.getCategories(action.application, action.filter).pipe(
          map(categories => GetCategoriesSuccess({ categories: categories.results })),
          catchError(error => of(GetCategoriesError({ error })))
        )
      )
    );
  }

  @Effect()
  public getItem(): Observable<Action> {
    return this.actions.pipe(
      ofType(CategoriesActionTypes.GET_ITEM),
      switchMap((action: any) =>
        this.categoriesService.getItem(action.application, action.id).pipe(
          map((item: any) =>
            GetCategoryItemSuccess({
              item: {
                id: item.id,
                name: item.name,
                date: item.creation_time,
                title: item.title,
                description: item.article || item.description,
                category: item.category,
                actions: item.actions,
                image: item.picturePublicUrl,
                rating: item.rating,
                picture: item.picturePublicUrl,
                use_case: item.use_case,
                average_rating: item.average_rating,
                tags: item.tags ? item.tags.map(tag => tag.name) : [],
                iconPublicUrl: item.iconPublicUrl || '',
                picturePublicUrl: item.picturePublicUrl || '',
                attachments: item.attachments,
                answers: item.answers,
                comments: item.comments,
                type: item.type,
                categories: item.categories
              }
            })
          )
        )
      )
    );
  }

  @Effect()
  public getCategory(): Observable<Action> {
    return this.actions.pipe(
      ofType(CategoriesActionTypes.GET_CATEGORY),
      switchMap((action: any) =>
        this.categoriesService
          .getCategory(action.application, action.id)
          .pipe(map((cat: ICategory) => GetCategorySuccess({
            category: {
              id: cat.id,
              name: cat.name,
              items: cat.items.map( (item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  date: item.creation_time,
                  title: item.title,
                  description: item.article || item.description,
                  category: item.category,
                  actions: item.actions,
                  image: item.picturePublicUrl,
                  rating: item.rating,
                  picture: item.picturePublicUrl,
                  use_case: item.use_case,
                  average_rating: item.average_rating,
                  tags: item.tags ? item.tags.map(tag => tag.name) : []
                };
              })
            }
          })))
      )
    );
  }

  @Effect({ dispatch: false })
  public setRating() {
    return this.actions.pipe(
      ofType(CategoriesActionTypes.SET_RATING),
      tap((action: any) => {
        this.categoriesService.setRating(action.id, action.rating);
      })
    );
  }

  constructor(private actions: Actions, private categoriesService: CategoriesService) {}
}
